import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Toolbar, Typography } from "@material-ui/core";

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    backgroundColor: "#F7FAFF",
  },
  highlight: {
    color: "white !important",
    backgroundColor: "#f2f2f2",
  },

  title: {
    flex: "1 1 100%",
    fontWeight: 900,
    color: theme.palette.primary.dark,
  },
}));

const ProductTableToolbar = ({ productsSelected, title, label }) => {
  const classes = useToolbarStyles();

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: productsSelected?.length > 0,
      })}
    >
      {productsSelected.length > 0 ? (
        <Typography className={classes.title} variant="h6" component="span">
          {productsSelected.length} {label}
        </Typography>
      ) : (
        <Typography
          className={classes.title}
          color="primary"
          variant="h5"
          id="tableTitle"
          component="span"
        >
          {title}
        </Typography>
      )}
    </Toolbar>
  );
};

export default ProductTableToolbar;
